import { productSelectorVariantModalStyles } from "@insite/content-library/Components/ProductSelectorVariantModal";
import { css } from "styled-components";

productSelectorVariantModalStyles.variantSelect = {
    labelPosition: "top",
    cssOverrides: {
        formInputWrapper: css`
            margin-bottom: 10px;
        `,
    },
};
